"use client";

import { X } from "lucide-react";
import { Button } from "./Button";
import { Textarea } from "./texttarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./dialog";
import moment from "moment/moment";
import "moment/locale/es";

interface ReviewModalProps {
  onClick: any;
  setMotivo: any;
  motivo: any;
  loading: any;
  booking: any;
  onClose: () => void;
}

export default function CancelModal({
  onClick,
  setMotivo,
  motivo,
  loading,
  booking,
  onClose,
}: ReviewModalProps) {
  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Cancela reserva</span>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <X className="w-4 h-4" />
            </Button>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {/* Booking Info */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium text-gray-900 mb-2">
              {booking.property_name || booking.excursion_name}
            </h3>
            <div className="text-sm text-gray-600 space-y-1">
              <div>Reserva #{booking.id}</div>
              <div>
                {`Checkin ${booking.checkin} Hrs ${moment(booking.start_date)
                  .locale("es")
                  .format("D [de] MMMM [de] YYYY")}`}{" "}
                -{" "}
                {`Checkout ${booking.checkout} Hrs ${moment(booking.end_date)
                  .locale("es")
                  .format("D [de] MMMM [de] YYYY")} `}
              </div>
              <div>{booking.guests} huéspedes</div>
            </div>
          </div>

          {/* Description */}
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-700">
              Describe el motivo de la cancelación de la reserva
            </label>
            <Textarea
              placeholder="Describe el motivo de la cancelación"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              rows={4}
              className="resize-none"
            />
            <div className="text-xs text-gray-500">
              {motivo.length}/500 caracteres
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex gap-3 pt-4">
            <Button variant="outline" onClick={onClose} className="flex-1">
              Cancelar
            </Button>
            <Button
              onClick={(e) => onClick(e)}
              disabled={loading}
              name="cancelar"
              className="flex-1 bg-[#8B9456] hover:bg-[#7A8249] text-white"
            >
              {loading ? "Cancelando..." : "Cancelar reserva"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
